import { formatNumber } from "~/utils/formatting"
import { formatName } from "~/utils/namingUtils"
import { usePreorderShortfallRows } from "~/hooks/usePreorderShortfallRows"
import { usePreorderWhyDialogStore } from "~/stores/preorder-why-dialog-store"

import { Card, CardContent, CardHeader, CardTitle } from "../Card"
import PreorderMatrix from "./PreorderMatrix"

type Props = {
  variantIds: string[]
  skuIds?: string[]
}

export default function PreorderFulfillmentCard({ variantIds, skuIds }: Props) {
  const { matrixRows, matrixTotals } = usePreorderShortfallRows(variantIds, { skuIds })
  const openDialog = usePreorderWhyDialogStore((s) => s.openDialog)

  if (matrixRows.length === 0) return null

  return (
    <Card className="w-[780px] max-w-[95vw]">
      <CardHeader>
        <div className="flex items-center gap-3">
          <CardTitle>
            <span className="text-icon-red">
              {formatName("unfulfillable_preorder", true, true)}:{" "}
              {formatNumber(matrixTotals.unfulfillable)}
            </span>
            <span className="text-fg-subtle"> · </span>
            <span className="text-icon-orange">
              {formatName("at_risk_preorder", true, true)}: {formatNumber(matrixTotals.atRisk)}
            </span>
          </CardTitle>
          <button
            className="ml-auto paragraph-sm font-semibold underline text-fg-subtle cursor-pointer shrink-0 bg-transparent border-0 p-0"
            onClick={() => openDialog({ variantIds, skuIds })}
          >
            Why?
          </button>
        </div>
      </CardHeader>
      <CardContent className="p-0 max-h-[380px] overflow-auto">
        <PreorderMatrix rows={matrixRows} totals={matrixTotals} />
      </CardContent>
    </Card>
  )
}
